// src/components/User/Home/HomePage.js
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Header from "../Header";
import Footer from "../Footer";

import HeroSection from "./HomePage/HeroSection";
import ExperienceSection from "./HomePage/ExperienceSection";
import WhatISolveSection from "./HomePage/WhatISolveSection";
import FounderProblemsSection from "./HomePage/FounderProblemsSection";
import Contact from "./HomePage/Contact";

import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    return (
        <main>
            <Helmet>
                <title>Anindya Chowdhury | Consumer Growth & Product Advisor</title>

                <meta
                    name="description"
                    content="Anindya Chowdhury helps consumer businesses improve acquisition, engagement, retention and monetization through growth, product, data and technology."
                />

                <link
                    rel="canonical"
                    href="https://anindyachowdhury.com/"
                />
            </Helmet>

            <Header />
            <HeroSection />
            <ExperienceSection />
            <WhatISolveSection />
            <FounderProblemsSection />
            <Contact />
            <Footer />
        </main>
    );
};

export default Home;
